// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Comercial_FunnelResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /dashboards/comercial/funnel.
 *
 * 4-stage commercial funnel: Orçado → Aprovado → Realizado → Recebido.
 *
 * Critical: each stage is scoped by its OWN date column so we don't conflate
 * dates of different events:
 *   - orcado:    orcamento_data
 *   - aprovado:  orcamento_data (no separate approval-date column exists in DB)
 *   - realizado: compromisso_data_hora_inicio
 *   - recebido:  contas_recebimentos.recebimento_data (joined via
 *                recebimento_origem='compromisso' AND
 *                recebimento_origem_id=compromisso_id)
 *
 * Unit gotcha — values are normalized to INT CENTS on the wire:
 *   - compromisso_total is stored as varchar-of-reais; model multiplies by 100
 *   - recebimento_valor is already stored as int cents
 *
 * The "Realizado vs Recebido" delta is THE key new dashboard insight: a
 * Realizado compromisso the customer never paid still counts in orcado_count
 * / aprovado_count / realizado_count and realizado_valor_cents, but NOT in
 * recebido_count / recebido_valor_cents.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Comercial_FunnelResponseDados {
orcado_count: number
orcado_valor_cents: number
aprovado_count: number
aprovado_valor_cents: number
realizado_count: number
realizado_valor_cents: number
recebido_count: number
recebido_valor_cents: number
conversao_orcado_aprovado: number
conversao_aprovado_realizado: number
conversao_realizado_recebido: number
}

export type Comercial_FunnelResponse = ApiResponse<Comercial_FunnelResponseDados>;

registerResponseContract('Comercial_FunnelResponse', {
  orcado_count:                 { type: 'number',  required: true },
  orcado_valor_cents:           { type: 'number',  required: true },
  aprovado_count:               { type: 'number',  required: true },
  aprovado_valor_cents:         { type: 'number',  required: true },
  realizado_count:              { type: 'number',  required: true },
  realizado_valor_cents:        { type: 'number',  required: true },
  recebido_count:               { type: 'number',  required: true },
  recebido_valor_cents:         { type: 'number',  required: true },
  conversao_orcado_aprovado:    { type: 'number',  required: true },
  conversao_aprovado_realizado: { type: 'number',  required: true },
  conversao_realizado_recebido: { type: 'number',  required: true },
})
